/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './service/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "multipass": {
        "nested": {
          "service": {
            "nested": {
              "DecryptEmailRequest": {
                "fields": {
                  "encryptedEmail": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DecryptEmailResponse": {
                "fields": {
                  "decryptedEmail": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.multipass.service.Error",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.DecryptEmailRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.DecryptEmailResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DecryptEmailRequest @ squareup/multipass/encryption.proto at 46:1
 */
export const DecryptEmailRequest = $root.lookupType('squareup.multipass.service.DecryptEmailRequest');
fixType(DecryptEmailRequest, {
  encryptedEmail: {
    required: true
  }
});
Builder.createAndAttachToType(DecryptEmailRequest);
/**
 * SOURCE DecryptEmailResponse @ squareup/multipass/encryption.proto at 51:1
 */
export const DecryptEmailResponse = $root.lookupType('squareup.multipass.service.DecryptEmailResponse');
fixType(DecryptEmailResponse);
Builder.createAndAttachToType(DecryptEmailResponse);